import React, { useContext, useEffect, useMemo, useState } from "react";
import { AskedQuestion } from "consumerhouse-shared";
import AuthContext from "../AuthContext";
import CenterContainer from "../components/CenterContainer";
import Title from "../components/Title";
import { CollapseContainer } from "../components/CollapseContainer";
import { useLanguage } from "../useLanguage";

export function FAQ() {
    const [questions, setQuestions] = useState<AskedQuestion[]>([]);
    // const groups = useMemo(
    //     () =>
    //         questions.reduce(
    //             (p, e) => ({ ...p, [e.category]: [...p[e.category], e] }),
    //             {} as {
    //                 [category: string]: AskedQuestion[];
    //             }
    //         ),
    //     [questions]
    // );
    const { client } = useContext(AuthContext);
    const language = useLanguage();

    useEffect(() => {
        client.fetch("/asked").then(setQuestions);
    }, []);

    return (
        <CenterContainer>
            <Title>{language("faq")}</Title>
            <ul style={{ listStyle: "none", margin: "3em 0" }}>
                {questions.map((question) => (
                    <li key={question.id} style={{ padding: 0, margin: 0 }}>
                        <CollapseContainer style={{ display: "block", margin: "0.8em 0" }} title={question.question}>
                            {question.response}
                        </CollapseContainer>
                    </li>
                ))}
            </ul>
            <p style={{ marginBottom: "10em" }}>{language("faq-no-answer")}</p>
        </CenterContainer>
    );
}
